/* ============================================
   BYTE-PRODUCT-CARD-GALLERY.JS
   Product card image gallery: swipe/drag + dots (single product gallery)
   ============================================ */

const DRAG_THRESHOLD = 15
const SWIPE_THRESHOLD = 30

function parseProductGallery(str) {
  if (!str || typeof str !== 'string') return []
  try {
    const decoded = str
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
    const parsed = JSON.parse(decoded)
    const arr = Array.isArray(parsed) ? parsed : []
    return arr.filter((u) => u && String(u).trim())
  } catch {
    return []
  }
}

function initCardGallery(wrap) {
  const data = wrap.dataset.productGallery
  if (!data) return

  const images = parseProductGallery(data)
  if (images.length === 0) return

  const mainImageWrap = wrap.querySelector('[data-product-card-main-image]')
  const mainImg = mainImageWrap?.querySelector('img')
  const dotsEl = wrap.querySelector('[data-product-card-dots]')
  const arrowsEl = wrap.querySelector('[data-product-card-arrows]')
  const prevBtn = wrap.querySelector('[data-product-card-arrow="prev"]')
  const nextBtn = wrap.querySelector('[data-product-card-arrow="next"]')
  const overlayLink = wrap.querySelector('.grid-item__overlay-link')
  if (!mainImg || !dotsEl) return

  let currentIndex = 0

  wrap._productCardGallerySetImages = function (newUrls) {
    if (!Array.isArray(newUrls) || newUrls.length === 0) return
    images.length = 0
    newUrls.forEach((u) => images.push(u))
    currentIndex = 0
    const url = images[0]
    if (url) {
      mainImg.src = url
      mainImg.srcset = url + ' 1x'
    }
    updateDots()
    updateArrows()
  }

  wrap._productCardGallerySetOverlayHref = function (href) {
    if (overlayLink && href) overlayLink.href = href
  }
  let startX = 0
  let dragStarted = false
  let justDragged = false
  let pointerIsDown = false

  function setImage(index) {
    if (images.length === 0) return
    const i = Math.max(0, Math.min(index, images.length - 1))
    currentIndex = i
    const url = images[i]
    if (url) {
      mainImg.src = url
      mainImg.srcset = url + ' 1x'
    }
    updateDots()
    updateArrows()
  }

  function updateArrows() {
    if (!arrowsEl) return
    if (images.length <= 1) {
      arrowsEl.hidden = true
      return
    }

    arrowsEl.hidden = false

    if (!prevBtn || !nextBtn) return

    const canGoPrev = currentIndex > 0
    const canGoNext = currentIndex < images.length - 1

    prevBtn.hidden = !canGoPrev
    nextBtn.hidden = !canGoNext

    prevBtn.disabled = !canGoPrev
    nextBtn.disabled = !canGoNext
  }

  function isMobileSwipeDisabled() {
    return (
      window.matchMedia('(max-width: 767px)').matches &&
      Boolean(wrap.closest('[data-product-card-no-swipe-mobile]'))
    )
  }

  function updateDots() {
    dotsEl.innerHTML = ''
    if (images.length <= 1) {
      dotsEl.hidden = true
      return
    }
    if (isMobileSwipeDisabled()) {
      dotsEl.hidden = true
      return
    }
    dotsEl.hidden = false

    images.forEach((_, k) => {
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'grid-product__gallery-dot' + (k === currentIndex ? ' is-active' : '')
      btn.setAttribute('aria-label', (k + 1) + ' / ' + images.length)
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        setImage(k)
      })
      btn.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true })
      dotsEl.appendChild(btn)
    })
  }

  function go(direction) {
    if (images.length <= 1) return
    setImage(currentIndex + direction)
  }

  function onArrowClick(direction) {
    return (e) => {
      e.preventDefault()
      e.stopPropagation()
      go(direction)
    }
  }

  const onPrevClick = onArrowClick(-1)
  const onNextClick = onArrowClick(1)

  prevBtn?.addEventListener('click', onPrevClick)
  nextBtn?.addEventListener('click', onNextClick)

  const mobileBreakpointMq = window.matchMedia('(max-width: 767px)')
  const onMobileBreakpointChange = () => {
    updateDots()
    updateArrows()
  }
  mobileBreakpointMq.addEventListener('change', onMobileBreakpointChange)

  function onDocumentMouseUp(e) {
    document.removeEventListener('mouseup', onDocumentMouseUp, true)
    document.removeEventListener('mousemove', onDocumentMouseMove, true)
    onPointerUp(e)
  }

  function onDocumentPointerUp(e) {
    document.removeEventListener('pointerup', onDocumentPointerUp, true)
    document.removeEventListener('pointermove', onDocumentPointerMove, true)
    onPointerUp(e)
  }

  function onDocumentMouseMove(e) {
    const x = e.clientX != null ? e.clientX : 0
    if (!dragStarted && Math.abs(x - startX) > DRAG_THRESHOLD) dragStarted = true
  }

  function onDocumentPointerMove(e) {
    const x = e.clientX != null ? e.clientX : 0
    if (!dragStarted && Math.abs(x - startX) > DRAG_THRESHOLD) dragStarted = true
  }

  function onPointerDown(e) {
    if (e.button !== 0 && e.type === 'mousedown') return
    if (wrap.closest('[data-product-card-no-swipe-mobile]') && window.matchMedia('(max-width: 767px)').matches) return
    pointerIsDown = true
    startX = e.clientX != null ? e.clientX : e.touches?.[0]?.clientX ?? 0
    dragStarted = false
    justDragged = false
    if (e.type === 'mousedown') {
      document.addEventListener('mouseup', onDocumentMouseUp, true)
      document.addEventListener('mousemove', onDocumentMouseMove, true)
    } else if (e.type === 'pointerdown') {
      document.addEventListener('pointerup', onDocumentPointerUp, true)
      document.addEventListener('pointermove', onDocumentPointerMove, true)
    }
  }

  wrap._productCardGalleryPointerDown = onPointerDown

  function onPointerMove(e) {
    if (!pointerIsDown) return
    const x = e.clientX != null ? e.clientX : e.touches?.[0]?.clientX ?? 0
    if (!dragStarted && Math.abs(x - startX) > DRAG_THRESHOLD) {
      dragStarted = true
      if (images.length > 1 && e.cancelable) e.preventDefault()
    }
  }

  function isReleaseInsideCard(e) {
    const x = e.changedTouches?.[0]?.clientX ?? e.clientX
    const y = e.changedTouches?.[0]?.clientY ?? e.clientY
    const el = document.elementFromPoint(x, y)
    return el && wrap.contains(el)
  }

  function onPointerUp(e) {
    if (!pointerIsDown) return
    if (e.type === 'mouseup') {
      document.removeEventListener('mouseup', onDocumentMouseUp, true)
      document.removeEventListener('mousemove', onDocumentMouseMove, true)
    } else if (e.type === 'pointerup') {
      document.removeEventListener('pointerup', onDocumentPointerUp, true)
      document.removeEventListener('pointermove', onDocumentPointerMove, true)
    }
    pointerIsDown = false
    if (!dragStarted) return
    if (!isReleaseInsideCard(e)) return
    const x = e.changedTouches?.[0]?.clientX ?? e.clientX
    const dx = x - startX
    if (Math.abs(dx) > SWIPE_THRESHOLD) {
      justDragged = true
      go(dx > 0 ? -1 : 1)
      e.preventDefault()
      e.stopPropagation()
    }
    setTimeout(() => { justDragged = false }, 100)
  }

  function preventClickIfDragged(e) {
    if (justDragged) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  const useCapture = true
  wrap.addEventListener('mousedown', onPointerDown, useCapture)
  wrap.addEventListener('mousemove', onPointerMove, useCapture)
  wrap.addEventListener('mouseup', onPointerUp, useCapture)
  wrap.addEventListener('mouseleave', onPointerUp, useCapture)
  wrap.addEventListener('touchstart', onPointerDown, { passive: true, capture: useCapture })
  wrap.addEventListener('touchmove', onPointerMove, { passive: false, capture: useCapture })
  wrap.addEventListener('touchend', onPointerUp, { passive: false, capture: useCapture })
  if (overlayLink) overlayLink.addEventListener('click', preventClickIfDragged, true)

  wrap._productCardGalleryCleanup = () => {
    mobileBreakpointMq.removeEventListener('change', onMobileBreakpointChange)
    wrap.removeEventListener('mousedown', onPointerDown, useCapture)
    wrap.removeEventListener('mousemove', onPointerMove, useCapture)
    wrap.removeEventListener('mouseup', onPointerUp, useCapture)
    wrap.removeEventListener('mouseleave', onPointerUp, useCapture)
    wrap.removeEventListener('touchstart', onPointerDown, useCapture)
    wrap.removeEventListener('touchmove', onPointerMove, useCapture)
    wrap.removeEventListener('touchend', onPointerUp, useCapture)
    overlayLink?.removeEventListener('click', preventClickIfDragged, true)
    prevBtn?.removeEventListener('click', onPrevClick)
    nextBtn?.removeEventListener('click', onNextClick)
  }

  setImage(0)
  updateDots()
  updateArrows()
}

function initAllCardGalleries() {
  document.querySelectorAll('[data-product-card-gallery]').forEach((wrap) => {
    if (wrap._productCardGalleryInit) return
    wrap._productCardGalleryInit = true
    initCardGallery(wrap)
  })
}

function initGalleriesInNode(node) {
  if (!node || typeof node.querySelectorAll !== 'function') return
  if (node.hasAttribute?.('data-product-card-gallery')) {
    if (!node._productCardGalleryInit) {
      node._productCardGalleryInit = true
      initCardGallery(node)
    }
    return
  }
  node.querySelectorAll('[data-product-card-gallery]').forEach((wrap) => {
    if (wrap._productCardGalleryInit) return
    wrap._productCardGalleryInit = true
    initCardGallery(wrap)
  })
}

function installProductCardGalleryCapture() {
  if (document._productCardGalleryCapture) return
  document._productCardGalleryCapture = true
  const isMobileNoSwipe = (wrap) =>
    window.matchMedia('(max-width: 767px)').matches && wrap.closest('[data-product-card-no-swipe-mobile]')
  const handleStart = (e) => {
    const wrap = e.target.closest('[data-product-card-gallery]')
    if (!wrap?._productCardGalleryPointerDown) return
    if (isMobileNoSwipe(wrap)) return
    e.stopPropagation()
    wrap._productCardGalleryPointerDown(e)
  }
  document.addEventListener('mousedown', handleStart, true)
  document.addEventListener('touchstart', handleStart, true)
  document.addEventListener('pointerdown', handleStart, true)
}

installProductCardGalleryCapture()

document.addEventListener('DOMContentLoaded', () => {
  initAllCardGalleries()
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) initGalleriesInNode(node)
    }
  })
  observer.observe(document.body, { childList: true, subtree: true })
})

if (document.readyState !== 'loading') {
  initAllCardGalleries()
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => initAllCardGalleries())
}
